const eCommerce = {
    createCoupon: () => "store/coupon",
    listCoupon: () => "store/coupon",
    updatedCoupon: (id:string) => `store/coupon/${id}`,
    detailCoupon: (id:string) => `store/coupon/${id}`,
    deleteCoupon: (id:string) => `store/coupon/${id}`,
    activeDeactivateCoupon: (id:string) => `store/coupon/${id}/toggle`,

    // for Lens Variety
    lensVariety: (id:string) => `store/lens/${id}`,
    updateLensVariety:()=>`store/lens`,

    // feedback form
    feedbackList:()=>'store/forms'

}

export default eCommerce